import React, { useCallback, useState } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { FlightDropdownOption } from 'components/Flights/types'

import InlineGroup from 'components/Common/InlineGroup'
import Clickable from 'components/Common/Clickable'
import FareDropdownMobileMenu from './FareDropdownMobileMenu'
import BodyText from 'components/Luxkit/Typography/BodyText'

const FareClassWrapper = styled(InlineGroup)`
  position: relative;
  width: 100%;
`

const FareDropdownToggle = styled(Clickable)`
  height: ${rem(48)};
  padding: 0 ${rem(16)};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  border-radius: ${props => props.theme.borderRadius.medium};
  border: 1px solid ${({ theme }) => theme.palette.neutral.five};
`

interface Props {
  options: Array<FlightDropdownOption>;
  selectedOption: FlightDropdownOption;
  className?: string;
  title: string;
  onOptionChange: (option: FlightDropdownOption) => void;
}

function FareDropdownMobile(props: Props) {
  const { options, selectedOption, className, title, onOptionChange } = props
  const [isOpen, setOpen] = useState(false)
  const [option, setOption] = useState(selectedOption)

  const handleOpen = useCallback(() => setOpen(true), [setOpen])

  const handleClose = useCallback(() => {
    setOpen(false)
    setOption(selectedOption)
  }, [setOpen, setOption, selectedOption])

  const onApply = useCallback(() => {
    setOpen(false)
    onOptionChange(option)
  }, [setOpen, onOptionChange, option])

  return (
    <FareClassWrapper className={className}>
      <FareDropdownToggle onClick={handleOpen}>
        <BodyText variant="medium" weight="bold">{selectedOption.label}</BodyText>
      </FareDropdownToggle>
      <FareDropdownMobileMenu
        open={isOpen}
        options={options}
        selectedOption={option}
        title={title}
        onClose={handleClose}
        onOptionChange={setOption}
        onApply={onApply}
      />
    </FareClassWrapper>
  )
}

export default FareDropdownMobile
